import { TbHexagonLetterNFilled } from "react-icons/tb";
import useAuthStore from "views/hooks/useAuthStore";
import DashboardSettings from "./DashboardSettings";
import { PiHandWavingFill } from "react-icons/pi";
import { Card } from "antd";

const WelcomeCard = () => {
  const userData = useAuthStore(state => state.userData);

  const userName = userData?.firstName + " " + userData?.lastName || "Utilisateur";

  return (
    <Card className="welcome-card" bordered={false}>
      <div className="welcome-card-content">
        <div className="welcome-card-avatar">
          <PiHandWavingFill style={{ fontSize: 80, color: "#3e849e" }} />
        </div>
        <div className="welcome-card-text">
          <h2 className="welcome-card-title">
            {userName}
            <TbHexagonLetterNFilled style={{ fontSize: 22, color: "#3e849e" }} />
          </h2>
          <p className="welcome-card-subtitle">
            C'est une bonne journée pour simplifier votre facturation !
          </p>
        </div>
        <div className="welcome-card-decoration">
          <DashboardSettings />
        </div>
      </div>
    </Card>
  );
};

export default WelcomeCard;
